import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Box, makeStyles } from '@material-ui/core';

import { Theme } from 'src/theme';
import UiHeader from './UiHeader';
import UiNavLeft from './UiNavLeft';
import UiNavRight from './UiNavRight';
import { RootState } from 'src/store';
import { editCurrentButton } from 'src/store/modules/trackings';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    minWidth: 1200,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    // overflow: 'hidden',
    backgroundColor: '#e5e5e5'
  },
  container: {
    height: 'calc(100vh - 3rem)',
    marginTop: '3rem',
    display: 'flex',
    flexDirection: 'row',
    minWidth: 1200
  },
  templateWrapper: {
    width: '100%',
    minWidth: 560,
    height: 'calc(100vh - 3rem)',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'

    // overflowX: 'scroll'
    // overflowY: 'hidden'
  },
  guide: {
    position: 'absolute',
    width: 47,
    height: 47,
    bottom: '2vw',
    right: '2vw',
    zIndex: 10000
  },

  sideWrapper: {
    width: '20rem',
    minWidth: '20rem'
  },
  buttonWrapper: {
    width: '2.5rem',
    height: '7.5rem',
    lineHeight: '120%',
    marginTop: '3rem',

    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    position: 'absolute',
    left: '13.25rem',

    color: '#fff',
    fontFamily: 'Archivo',
    fontSize: '0.75rem',
    fontStyle: 'normal',
    fontWeight: 700,

    writingMode: 'vertical-rl',
    textOrientation: 'upright',
    borderRadius: '0 1rem 1rem 0',
    backgroundColor: '#646464'
  },

  bottomWrapper: {
    width: 'calc(100% - 33.25rem)',
    minWidth: '41.75rem',
    position: 'absolute',
    bottom: 0,
    left: '13.25rem',
    backgroundColor: '#fff'
  }
}));

const DashboardLayout: any = ({ children }) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  let currentButton = useSelector(
    (state: RootState) => state.trackings.currentButton
  );

  return (
    <div className={classes.root}>
      <UiHeader />
      <div className={classes.container}>
        <Box className={classes.sideWrapper}>
          <UiNavLeft />
          {[...Array(2)].map((_: any, idx: number) => {
            return (
              <Box
                key={idx}
                className={classes.buttonWrapper}
                style={{
                  top: `calc(7.5 * ${idx}rem)`,
                  backgroundColor: currentButton === idx ? '#434343' : '#646464'
                }}
                onClick={() => {
                  dispatch(editCurrentButton(idx));
                }}
              >
                BUTTON{idx + 1}
              </Box>
            );
          })}
        </Box>
        <Box className={classes.templateWrapper}>{children}</Box>
        <Box className={classes.sideWrapper}>
          <UiNavRight />
        </Box>
      </div>
    </div>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node
};

export default DashboardLayout;
